import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';

function StripeFailure() {
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
        }}>
            <Result
                status="error"
                title="Payment Failed"
                subTitle="Something went wrong with your payment. Please try again."
                extra={[
                    <Button type="primary" key="console" onClick={() => navigate('/')}>
                        Go Back Home
                    </Button>
                ]}
            />
        </div>
    );
}

export default StripeFailure;
